import React from 'react';

import TwitterIcon from './twitter';
import LinkedinIcon from './linkedin';
import InstagramIcon from './instagram';
import ResumeIcon from './resume';

import GithubIcon from './github';
import DarkIcon from './dark';
import LightIcon from './light';
import QuoteIcon from './quote';
import DotCorner from './dotcorner';
import Hand from './hand';
const ICONS = {
  twitter: <TwitterIcon />,
  linkedin: <LinkedinIcon />,
  github: <GithubIcon />,
  instagram: <InstagramIcon />,
  dark: <DarkIcon />,
  light: <LightIcon />,
  quote: <QuoteIcon />,
  dotcorner: <DotCorner />,
  hand: <Hand />,
  resume: <ResumeIcon />,
};

const Icon = props => {
  return <div>{ICONS[props.iconName]}</div>;
};

export default Icon;
